import React from 'react';
import { MenuConfig } from '@tencent/workbench';
import pluginIcon from '@tencent/docs-design-resources/pc/svg/toolbar_plugin.svg';
import  menuAdd from '@tencent/docs-design-resources/pc/svg/menu_add.svg';
import i18n from '@i18next/i18n';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { TDWOperationType, TDWActionType, TDWModuleType, TDWVer5Type, EventCodeType, TDWFileType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { MallType } from './types';

export const config = {
    twdConfig: {
        handleFunction: (type: MallType) => {
            const map = {
                [MallType.SETTING]: {
                    opername: TDWOperationType.DOC_ADDON,
                    module: TDWModuleType.ADDON_LIST,
                    action: TDWActionType.MANAGE_ADDON,
                    ver5: TDWVer5Type.DOC_DETAIL_TOOLBAR,
                    eventcode: EventCodeType.DOC_ADDON_ADDON_LIST_MANAGE_ADDON,
                    file_type: TDWFileType.SLIDE,
                },
                [MallType.MALL]: {
                    opername: TDWOperationType.DOC_ADDON,
                    module: TDWModuleType.ADDON_LIST,
                    action: TDWActionType.GET_ADDON,
                    ver5: TDWVer5Type.DOC_DETAIL_TOOLBAR,
                    eventcode: EventCodeType.DOC_ADDON_ADDON_LIST_GET_ADDON,
                    file_type: TDWFileType.SLIDE,
                },
            };
            return map[type];
        },
    },
};

const needDisable = (browser.isPc && browser.isMiniProgram);

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.ADDON_MALL_SETTING,
        content: i18n.t<string>('管理插件'),
        icon: <img src={pluginIcon} />,
        tooltip: needDisable ? {
            content: i18n.t('请到电脑客户端或浏览器中使用'),
            placement: 'left',
            style: {
                display: 'block',
            },
        } : undefined,
    },
    {
        name: ActionType.ADDON_MALL_SHOP,
        content: i18n.t<string>('获取更多'),
        icon: <img src={menuAdd} />,
        tooltip: needDisable ? {
            content: i18n.t('请到电脑客户端或浏览器中使用'),
            placement: 'left',
            style: {
                display: 'block',
            },
        } : undefined,
    },
];
